import type { QueryClient } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

type Loader<T> = (params: T, queryClient: QueryClient) => Promise<void>;

export function usePreload<T>(loader: Loader<T>) {
  const queryCLient = useQueryClient();

  return useCallback(
    (params: T) => {
      loader(params, queryCLient).catch((error) => {
        console.error("Failed to preload data", error);
      });
    },
    [loader, queryCLient],
  );
}
